import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  title:string = '';
  content:string = '';
  primaryButtonText:string = '';
  secondaryButtonText:string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.title = data.title;
    this.content = data.content;
    this.primaryButtonText = data.primaryButtonText;
    this.secondaryButtonText = data.secondaryButtonText;
  }
}
